import { getOptDes as getEmptyLayoutComponentOptDes } from "dependencies/emptyLayout/optDes"
import { materialLoader } from "core/materialLoader"
export const allGetOptDesEv = {
  ...materialLoader.getAllOptDes(),
  getEmptyLayoutComponentOptDes
}
